var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("to see the definition:")]),_c('br'),_c('a',{attrs:{"href":_vm.constructURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.constructURL)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }